import {
  GET_VENDOR_DOCUMENTS_REQUEST,
  GET_VENDOR_DOCUMENTS_SUCCESS,
  GET_VENDOR_DOCUMENTS_FAILURE,
  UPLOAD_VENDOR_DOCUMENT_REQUEST,
  UPLOAD_VENDOR_DOCUMENT_SUCCESS,
  UPLOAD_VENDOR_DOCUMENT_FAILURE,
  DELETE_VENDOR_DOCUMENT_REQUEST,
  DELETE_VENDOR_DOCUMENT_SUCCESS,
  DELETE_VENDOR_DOCUMENT_FAILURE,
  GET_SHARE_TARGETS_REQUEST,
  GET_SHARE_TARGETS_SUCCESS,
  GET_SHARE_TARGETS_FAILURE,
  SHARE_VENDOR_DOCUMENT_REQUEST,
  SHARE_VENDOR_DOCUMENT_SUCCESS,
  SHARE_VENDOR_DOCUMENT_FAILURE,
  UPDATE_VENDOR_DOCUMENT_STATUS_REQUEST,
  UPDATE_VENDOR_DOCUMENT_STATUS_SUCCESS,
  UPDATE_VENDOR_DOCUMENT_STATUS_FAILURE,
} from "./type";

export const getVendorDocumentsRequest = (data) => {
  return { type: GET_VENDOR_DOCUMENTS_REQUEST, payload: data };
};

export const getVendorDocumentsSuccess = (data) => {
  return { type: GET_VENDOR_DOCUMENTS_SUCCESS, payload: data };
};

export const getVendorDocumentsFailure = (data) => {
  return { type: GET_VENDOR_DOCUMENTS_FAILURE, payload: data };
};

export const uploadVendorDocumentRequest = (data) => {
  return { type: UPLOAD_VENDOR_DOCUMENT_REQUEST, payload: data };
};

export const uploadVendorDocumentSuccess = (data) => {
  return { type: UPLOAD_VENDOR_DOCUMENT_SUCCESS, payload: data };
};

export const uploadVendorDocumentFailure = (data) => {
  return { type: UPLOAD_VENDOR_DOCUMENT_FAILURE, payload: data };
};

export const deleteVendorDocumentRequest = (data) => {
  return { type: DELETE_VENDOR_DOCUMENT_REQUEST, payload: data };
};

export const deleteVendorDocumentSuccess = (data) => {
  return { type: DELETE_VENDOR_DOCUMENT_SUCCESS, payload: data };
};

export const deleteVendorDocumentFailure = (data) => {
  return { type: DELETE_VENDOR_DOCUMENT_FAILURE, payload: data };
};

export const getShareTargetsRequest = (data) => {
  return { type: GET_SHARE_TARGETS_REQUEST, payload: data };
};

export const getShareTargetsSuccess = (data) => {
  return { type: GET_SHARE_TARGETS_SUCCESS, payload: data };
};

export const getShareTargetsFailure = (data) => {
  return { type: GET_SHARE_TARGETS_FAILURE, payload: data };
};

export const shareVendorDocumentRequest = (data) => {
  return { type: SHARE_VENDOR_DOCUMENT_REQUEST, payload: data };
};

export const shareVendorDocumentSuccess = (data) => {
  return { type: SHARE_VENDOR_DOCUMENT_SUCCESS, payload: data };
};

export const shareVendorDocumentFailure = (data) => {
  return { type: SHARE_VENDOR_DOCUMENT_FAILURE, payload: data };
};

export const updateVendorDocumentStatusRequest = (data) => {
  return { type: UPDATE_VENDOR_DOCUMENT_STATUS_REQUEST, payload: data };
};

export const updateVendorDocumentStatusSuccess = (data) => {
  return { type: UPDATE_VENDOR_DOCUMENT_STATUS_SUCCESS, payload: data };
};

export const updateVendorDocumentStatusFailure = (data) => {
  return { type: UPDATE_VENDOR_DOCUMENT_STATUS_FAILURE, payload: data };
};
